import http from '@/extensions/http'
import { api_error, ENDPOINTS, localizedRouteName, ROUTES } from '@/helpers'
import router from '@/router'

export const hunter = {
  state: {
    avatar: {
      accessory: 1,
      bottom: 2,
      hair: 3,
      hat: 4,
      object: 5,
      shoes: 6,
      skin: 7,
      top: 8,
    },
    completed_riddles_count: 0,
    email: null,
    group_size: null,
    has_phone: false,
    level: 1,
  },
  mutations: {
    updateAvatarClothingType(state, { id, type }) {
      state.avatar[type] = id
    },
    setHunter(state, hunterData) {
      state.avatar = hunterData.avatar
      state.completed_riddles_count = hunterData.completed_riddles_count
      state.group_size = hunterData.group_size
      state.has_phone = hunterData.has_phone
      state.level = hunterData.level
    },
    updateCompletedRiddleCount(state, newCompleted = 1) {
      state.completed_riddles_count += newCompleted
    },
    updateHasPhone(state, hasPhone = true) {
      state.has_phone = hasPhone
    },
    updateGroupSize(state, size) {
      state.group_size = size
    },
    updateHunterEmail(state, email) {
      state.email = email
    },
    updateLevel(state, currentRiddle) {
      if (!currentRiddle) state.level = 2
    },
  },
  actions: {
    async fetchShareImage() {
      try {
        const { data } = await http.$post(ENDPOINTS.HUNTER.AVATAR.SHARE)
        return data
      } catch ({ response }) {
        if (response) return api_error(response)
      }
    },
    async saveAvatar(context) {
      try {
        await http.$post(ENDPOINTS.HUNTER.AVATAR.UPDATE, context.state.avatar)
      } catch ({ response }) {
        if (response) return api_error(response)
      }
    },
    async saveRiddle(context, payload) {
      try {
        await http.$post(ENDPOINTS.HUNTER.RIDDLE.STORE, payload)
        await context.dispatch('updateCompletedRiddleCount')
        await context.dispatch('updateCurrentRiddle')
        await context.dispatch('updateLevel')
      } catch ({ response }) {
        if (response) return api_error(response)
      }
    },
    setHunter(context, hunterData) {
      context.commit('setHunter', hunterData)
    },
    updateAvatarClothingType(context, payload) {
      context.commit('updateAvatarClothingType', payload)
    },
    updateCompletedRiddleCount(context) {
      context.commit('updateCompletedRiddleCount')
    },
    async updateHunter(context, payload) {
      try {
        await http.$post(ENDPOINTS.HUNTER.UPDATE, payload)
        if (payload.phone) {
          context.commit('updateHasPhone')
          await router.push({ name: localizedRouteName(ROUTES.AUTH.GROUP_SIZE) })
        } else if (payload.group_size) {
          context.commit('updateGroupSize', payload.group_size)
          await router.push({ name: localizedRouteName(ROUTES.HUNT.WELCOME) })
        }
      } catch ({ response }) {
        if (response) return api_error(response)
      }
    },
    updateHunterEmail(context, email) {
      context.commit('updateHunterEmail', email)
    },
    updateLevel(context) {
      context.commit('updateLevel', context.rootState.riddle.current)
    },
  },
}
